import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '探索',
    links: [
      { name: '首页', path: '/' },
      { name: '活动分类', path: '/category/outdoor' },
      { name: '热门文章', path: '/article/article-1' },
    ],
  },
  {
    title: '关于',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '品牌故事', path: '/about' },
      { name: '联系我们', path: '/about' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { name: '户外运动', path: '/category/outdoor' },
      { name: '音乐艺术', path: '/category/music' },
      { name: '美食烹饪', path: '/category/food' },
      { name: '读书学习', path: '/category/reading' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-2xl font-heading text-background-50 whitespace-nowrap"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              17c一起
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              相聚共享，连接你我他。<br />
              发现志同道合的朋友，开启全新社交体验。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-label font-medium text-background-100 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 17c一起. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}